import React from 'react';
import { Section } from './ui/Section';
export function OpeningHook() {
  return <Section className="bg-[#FFF0EB]" data-id="element-119">
      <div className="text-center max-w-3xl mx-auto space-y-6" data-id="element-120">
        <p className="text-xl md:text-2xl text-[#2D2D2D] leading-relaxed font-serif italic" data-id="element-121">
          "Te miras al espejo post-ducha. Tocas la flacidez. Lágrimas. Ropa no
          cierra. Niños lloran, trabajo espera. Has probado dietas, videos
          YouTube, fajas. Nada."
        </p>

        <div className="w-16 h-1 bg-[#C9A84C] mx-auto my-8 rounded-full" data-id="element-122" />

        <p className="text-2xl md:text-3xl font-bold text-[#0D5C63]" data-id="element-123">
          Esta guía termina eso. <br data-id="element-124" />
          <span className="text-[#C9A84C]" data-id="element-125">
            21 días, abdomen firme visible.
          </span>
        </p>
      </div>
    </Section>;
}